import { render, staticRenderFns } from "./allcustomer.vue?vue&type=template&id=dce10a2a&scoped=true&"
import script from "./allcustomer.vue?vue&type=script&lang=js&"
export * from "./allcustomer.vue?vue&type=script&lang=js&"
import style0 from "./allcustomer.vue?vue&type=style&index=0&id=dce10a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce10a2a",
  null
  
)

export default component.exports